function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2020(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19.62,
    height: 8.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.172857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 4.105
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.21,
    width: 19.62,
    height: 11.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 13.84
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.48,
    width: 19.62,
    height: 21.09,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 30.025
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40.56,
    width: 19.62,
    height: 24.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9240000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 53.045
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 65.54,
    width: 19.62,
    height: 26.91,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 78.995
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 92.45,
    width: 19.62,
    height: 26.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9240000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 105.94500000000001
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 119.44,
    width: 19.62,
    height: 27.46,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 133.17
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 146.9,
    width: 19.62,
    height: 28.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9620000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 160.925
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 174.95,
    width: 19.62,
    height: 31.16,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.905
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 190.53
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 206.11,
    width: 19.62,
    height: 31.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9240000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 222.085
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 238.05,
    width: 19.62,
    height: 33.83,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9620000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 254.965
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 271.88,
    width: 19.62,
    height: 34.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.802857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 289.125
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 306.38,
    width: 19.62,
    height: 35.18,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 323.96999999999997
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 341.56,
    width: 19.62,
    height: 39.56,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 361.34000000000003
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 381.13,
    width: 19.62,
    height: 40.87,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 401.565
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 421.99,
    width: 19.62,
    height: 42.75,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9240000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 443.365
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 464.74,
    width: 19.62,
    height: 44.37,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 486.925
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 509.11,
    width: 19.62,
    height: 45.7,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7836363636363637
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 531.96
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 554.81,
    width: 19.62,
    height: 46.53,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 578.0749999999999
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 601.33,
    width: 19.62,
    height: 48.07,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 625.365
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 649.4,
    width: 19.62,
    height: 50.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9240000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.81,
    y: 674.6999999999999
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 0,
    width: 27.94,
    height: 36.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.656666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.59,
    y: 18.02
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.56,
    y: 0,
    width: 29.66,
    height: 36.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2371428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.39,
    y: 18.02
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.21,
    y: 0,
    width: 30.41,
    height: 36.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.41499999999999,
    y: 18.02
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.63,
    y: 0,
    width: 30.86,
    height: 36.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1433333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.06,
    y: 18.02
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.48,
    y: 0,
    width: 31.62,
    height: 36.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.162
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 154.29,
    y: 18.02
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.11,
    y: 0,
    width: 32.18,
    height: 36.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.597142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.20000000000002,
    y: 18.02
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.28,
    y: 0,
    width: 36.36,
    height: 36.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 220.46,
    y: 18.02
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.64,
    y: 0,
    width: 38.92,
    height: 36.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.09999999999997,
    y: 18.02
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.56,
    y: 0,
    width: 39.74,
    height: 36.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.004444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.43,
    y: 18.02
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.3,
    y: 0,
    width: 40.42,
    height: 36.04,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.51,
    y: 18.02
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.71,
    y: 0,
    width: 42.14,
    height: 36.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 378.78,
    y: 18.02
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399.85,
    y: 0,
    width: 48.96,
    height: 36.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.604
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 424.33000000000004,
    y: 18.02
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.82,
    y: 0,
    width: 49.03,
    height: 36.04,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 473.335,
    y: 18.02
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.85,
    y: 0,
    width: 49.8,
    height: 36.04,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.004444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 522.75,
    y: 18.02
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.65,
    y: 0,
    width: 50.21,
    height: 36.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0033333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 572.755,
    y: 18.02
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.86,
    y: 0,
    width: 51.05,
    height: 36.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.208
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.385,
    y: 18.02
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 648.9,
    y: 0,
    width: 51.1,
    height: 36.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.4499999999999,
    y: 18.02
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 36.04,
    width: 45.33,
    height: 41.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.218
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 56.585
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 77.13,
    width: 45.33,
    height: 41.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 98.095
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 119.06,
    width: 45.33,
    height: 42.34,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.585
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 140.23000000000002
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 161.4,
    width: 45.33,
    height: 42.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.140000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 182.82
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 204.24,
    width: 45.33,
    height: 44.45,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.408333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 226.465
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 248.68,
    width: 45.33,
    height: 45.01,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.62625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 271.185
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 293.69,
    width: 45.33,
    height: 47.41,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.3325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 317.395
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 341.11,
    width: 45.33,
    height: 49.53,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.065999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 365.875
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 390.63,
    width: 45.33,
    height: 49.85,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.036666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 415.555
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 440.48,
    width: 45.33,
    height: 50.29,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 465.625
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 490.77,
    width: 45.33,
    height: 50.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.475714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 515.97
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 541.18,
    width: 45.33,
    height: 51.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.66625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 566.925
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 592.67,
    width: 45.33,
    height: 51.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.66625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 618.545
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 644.41,
    width: 45.33,
    height: 55.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.285,
    y: 672.2049999999999
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 36.04,
    width: 49.12,
    height: 51.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.017142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 89.51,
    y: 61.875
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.07,
    y: 36.04,
    width: 49.79,
    height: 51.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.596666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.965,
    y: 61.875
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.86,
    y: 36.04,
    width: 54.24,
    height: 51.67,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7411111111111115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.98000000000002,
    y: 61.875
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.1,
    y: 36.04,
    width: 55.3,
    height: 51.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.381428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.75,
    y: 61.875
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.4,
    y: 36.04,
    width: 58.25,
    height: 51.67,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.611666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.525,
    y: 61.875
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.66,
    y: 36.04,
    width: 58.65,
    height: 51.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.611666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.985,
    y: 61.875
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.31,
    y: 36.04,
    width: 59.1,
    height: 51.67,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.167
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 419.86,
    y: 61.875
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.4,
    y: 36.04,
    width: 60.88,
    height: 51.67,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.611666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 479.84,
    y: 61.875
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.28,
    y: 36.04,
    width: 62.72,
    height: 51.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.381428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.64,
    y: 61.875
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 573,
    y: 36.04,
    width: 62.89,
    height: 51.67,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.445,
    y: 61.875
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 635.89,
    y: 36.04,
    width: 64.11,
    height: 51.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.45875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.9449999999999,
    y: 61.875
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 87.71,
    width: 60.26,
    height: 59.96,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.993333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.08,
    y: 117.69
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 147.67,
    width: 60.26,
    height: 62.84,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.5325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.08,
    y: 179.08999999999997
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 210.51,
    width: 60.26,
    height: 63.04,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.5325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.08,
    y: 242.03
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 273.55,
    width: 60.26,
    height: 65.65,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.052
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.08,
    y: 306.375
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 339.2,
    width: 60.26,
    height: 69.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.608571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.08,
    y: 373.93
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 408.66,
    width: 60.26,
    height: 70.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.026
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.08,
    y: 443.845
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 479.03,
    width: 60.26,
    height: 71.53,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.608571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.08,
    y: 514.795
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 550.56,
    width: 60.26,
    height: 73.92,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.608571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.08,
    y: 587.52
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 624.48,
    width: 60.26,
    height: 75.52,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.695555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.08,
    y: 662.24
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.2,
    y: 87.71,
    width: 61.14,
    height: 75.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.77,
    y: 125.625
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.34,
    y: 87.71,
    width: 62.07,
    height: 75.83,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.375,
    y: 125.625
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.41,
    y: 87.71,
    width: 64.96,
    height: 75.83,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.991999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.89,
    y: 125.625
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.37,
    y: 87.71,
    width: 68.18,
    height: 75.83,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 347.46000000000004,
    y: 125.625
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.55,
    y: 87.71,
    width: 68.24,
    height: 75.83,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.648
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 415.67,
    y: 125.625
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.79,
    y: 87.71,
    width: 79.97,
    height: 75.83,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.425555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.77500000000003,
    y: 125.625
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.76,
    y: 87.71,
    width: 84.49,
    height: 75.83,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.638333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 572.005,
    y: 125.625
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 614.25,
    y: 87.71,
    width: 85.75,
    height: 75.83,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.47875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 657.125,
    y: 125.625
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.2,
    y: 163.54,
    width: 83.33,
    height: 78.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.626
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.865,
    y: 202.605
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.2,
    y: 241.67,
    width: 83.33,
    height: 88.8,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.904285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.865,
    y: 286.07
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.2,
    y: 330.47,
    width: 83.33,
    height: 90.47,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.888333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.865,
    y: 375.70500000000004
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.2,
    y: 420.94,
    width: 83.33,
    height: 91.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.41625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.865,
    y: 466.755
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.2,
    y: 512.57,
    width: 83.33,
    height: 93.21,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.8325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.865,
    y: 559.1750000000001
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.2,
    y: 605.79,
    width: 83.33,
    height: 94.21,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.41625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.865,
    y: 652.895
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.53,
    y: 163.54,
    width: 82.59,
    height: 96.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.176666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.825,
    y: 211.95999999999998
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.12,
    y: 163.54,
    width: 93.76,
    height: 96.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.394285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 338,
    y: 211.95999999999998
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.87,
    y: 163.54,
    width: 101.99,
    height: 96.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.865,
    y: 211.95999999999998
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 486.86,
    y: 163.54,
    width: 105.78,
    height: 96.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.75,
    y: 211.95999999999998
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.64,
    y: 163.54,
    width: 107.36,
    height: 96.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.3199999999999,
    y: 211.95999999999998
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.53,
    y: 260.38,
    width: 115.31,
    height: 100.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.185,
    y: 310.765
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.53,
    y: 361.15,
    width: 115.31,
    height: 101.4,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.218181818181819
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.185,
    y: 411.84999999999997
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.53,
    y: 462.55,
    width: 115.31,
    height: 113.18,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.318000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.185,
    y: 519.14
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.53,
    y: 575.73,
    width: 115.31,
    height: 124.27,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.41375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.185,
    y: 637.865
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.84,
    y: 260.38,
    width: 101.67,
    height: 156.95,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.67499999999995,
    y: 338.855
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.51,
    y: 260.38,
    width: 113.74,
    height: 156.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.248571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 482.38,
    y: 338.855
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.24,
    y: 260.38,
    width: 160.76,
    height: 156.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.61875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.62,
    y: 338.855
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.84,
    y: 417.33,
    width: 177.92,
    height: 282.67,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.174545454545452
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.79999999999995,
    y: 558.665
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.76,
    y: 417.33,
    width: 198.24,
    height: 282.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 49.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.88,
    y: 558.665
  }, "\n        Wake\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2020);
export default __webpack_public_path__ + "static/media/2020.2f53fb94348104f92361638d35c97653.svg";
export { ForwardRef as ReactComponent };